import React from 'react';

import useStyles from './styles';

import { Operator } from '../../types';

interface Props {
    label: Operator;
    color?: 'default' | 'red' | 'blue';
    className?: string;
}

const OperatorTag: React.FC<Props> = ({ label, color, className }) => {
    const { classes, cx } = useStyles();
    return (
        <span className={cx(classes.outline, className)}>
            <span
                className={cx(classes.background, {
                    [classes._default]: color === 'default',
                    [classes._blue]: color === 'blue',
                    [classes._red]: color === 'red'
                })}
            >
                <span className={classes.label}>{label}</span>
            </span>
        </span>
    );
};

export default OperatorTag;
